export const API = {
    Get_PO_Product_Inward_And_Inventory: '/api/v1/ProductHeaderItemMaster/GetPOProductInwardAndInventory',
    Get_PO_Product_By_Id: '/api/v1/ProductHeaderItemMaster/GetPOProductById',
    Update_PO_Product_Inwards: '/api/v1/ProductHeaderItemMaster/UpdatePOProductInwards',
    Assign_Product_To_Store: '/api/v1/ProductHeaderItemMaster/AssignProductToStore',
    Reject_PO_Product: '/api/v1/ProductHeaderItemMaster/RejectPOProduct',
    Get_Assign_Product_List: '/api/v1/ProductHeaderItemMaster/GetAssignProductList',
    Get_PO_Rejected_Products: '/api/v1/ProductHeaderItemMaster/GetPORejectedProducts',
    Get_All_Assign_Product_Invoice: '/api/v1/ProductHeaderItemMaster/GetAllAssignProductInvoice',
    Get_Row_Material_By_PO_Product_Id: '/api/v1/ProductHeaderItemMaster/GetRowMaterialByPOProductId',
    Generate_Mayave_To_Store_Chalan: '/api/v1/ProductHeaderItemMaster/GenrateMayaveToStoreChalan'
}